// extracted by mini-css-extract-plugin
export var actionButton = "_rm-0";
export var actionMenuContainer = "_rm-i";
export var bubble = "_rm-2";
export var bubbleActionMenu = "_rm-j";
export var bubbleContext = "_rm-6";
export var bubbleItems = "_rm-7";
export var customer = "_rm-3";
export var divider = "_rm-8";
export var fileList = "_rm-9";
export var hiddenComment = "_rm-o";
export var infoAbove = "_rm-a";
export var internal = "_rm-4";
export var lightActionButton = "_rm-1";
export var link = "_rm-b";
export var merchant = "_rm-5";
export var message = "_rm-c";
export var profilePicture = "_rm-e";
export var quillToolbarContainer = "_rm-f";
export var senderDate = "_rm-g";
export var senderDateCustomer = "_rm-h";
export var senderName = "_rm-d";
export var time = "_rm-k";
export var uploadedImage = "_rm-l";
export var username = "_rm-m";
export var xsmall = "_rm-n";